<template>
  <div id="about-this-app">
    <call />
    <!-- main -->
    <main>
      <section>
        <div class="l-main l-main--bg-border l-main--no-pd-bot l-main--grey">
          <div class="l-check-cart">
            <div class="l-check-cart__head">
              <div class="l-check-cart__title l-check-cart__title-small mt-24 mb-24">
                アカウント情報取得エラー
              </div>
              <div class="l-check-cart__title l-check-cart__title-small mb-32">
                <span>アカウント情報が確認できませんでした。<br>お手数ですが、再度登録処理を行ってください。</span>
              </div>
            </div>
            <div class="l-auth__box">
              <a href="#" @click.prevent="initUser" class="c-btn c-btn--center c-btn__red">次へ</a>
            </div>
          </div>
        </div>
      </section>
    <div class="layer" :class="{ fade: !loading }"></div>
    <div class="screen-loader loader--style1" :class="{ fade: !loading }" title="0">
      <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
        <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
        <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"></path>
      </svg>
    </div>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import { Tenant } from "../plugin/mixin.js";
import { Common } from "../common/common.js";
//import firebase from "../common/firebaseProject.js";
import { DB, USER_COLLECTION_KEY } from "../config/const.js";
import firebaseApp from "../common/firebaseProject";

import Vue from "vue";
window._ver = "__VERSION__";

export default Vue.extend({
  name: 'UserNotfound',
  data() {
    return {
      "version": "__VERSION__",
      loading: false
    }
  },
  mixins: [Tenant],
  mounted() {
    Common.initDom();
  },
  methods: {
    initUser() {
      Common.loadingShow();

      firebaseApp.auth().signInAnonymously()
        .then(async () => {
          const uid = firebaseApp.auth().currentUser.uid;
          const data = {
            gender: '',
            birthdayYear: '',
            birthdayMonth: '',
            birthmonth: '',
            zipcode: '',
          };
          await DB.collection(USER_COLLECTION_KEY).doc(uid).set(data);

          this.$store.dispatch('clearCart');
          this.$store.dispatch('checkLogin', uid)
          this.$store.dispatch('setLoginType', '');

          this.$router.push('/account/registration');
          const idToken = await this.getIdToken();
          if (!idToken) return;
          const callable = firebaseApp.functions('asia-northeast1').httpsCallable('exchangeToken');
          const result = await callable({ idToken: idToken, authType: "anon" })
          .catch(e => {
            throw e;
          })
          if (result.data.status == 'SUCCEED'){
            Common.messageHandlers('login_anonymous', { customToken: result.data.firebaseToken });
          }
          Common.loadingHide();
        })
        .catch(err => {
          Common.loadingHide();
        })
    }
  }
})
</script>